import React from "react";
import styled from "styled-components";
import { CategoryJsonModel } from "../../models/BlockTransportSystemJsonModel";

interface IProps {
  categories: CategoryJsonModel[];
  selectedCategoryIds: string[];
  onChangeSelectedCategoryIds: (ids: string[]) => void;
}

const ModeListBox = ({
  categories,
  selectedCategoryIds,
  onChangeSelectedCategoryIds
}:IProps) => {
  const isSelected = (category: CategoryJsonModel) =>
  selectedCategoryIds.includes(category.id);

const toggleCategory = (category: CategoryJsonModel) => {
  if (isSelected(category)) {
    onChangeSelectedCategoryIds(
      selectedCategoryIds.filter(id => id !== category.id)
    );
  } else {
    onChangeSelectedCategoryIds([...selectedCategoryIds, category.id]);
  }
};

  return (
        <ListContainer>
      {categories?.map(category => {
        const selected = isSelected(category);

        return (
          <Item key={category.id} selected={selected}>
            <input
              type="checkbox"
              checked={selected}
              onChange={() => toggleCategory(category)}
            />
            <Label onClick={() => toggleCategory(category)}>
              {`${category.name} [${
                category?.dedicatedProducts
                  ? [...category.dedicatedProducts]
                  : ""
              }]`}
            </Label>
          </Item>
        );
      })}
    </ListContainer>
  )
}

export default ModeListBox;

const ListContainer = styled.div`
  height: 500px;
  width: 950px;
  overflow: scroll;
`;

const NameText = styled.div<{selected: boolean}>`
  background-color: ${(props) => props.selected ? "#3969ed" : "#f0f0f0"};
  font-size: 15px;
  margin: 2px;
  padding: 2px;
`;

const Item = styled.div<{selected: boolean}>`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.selected ? "#3969ed" : "#f0f0f0"};
  margin: 2px;
  padding: 2px;
`;

const Label = styled.label`
  margin-left: 8px;
  cursor: pointer;
`;